<template>
  <div class="parkingConfiguration">
    <div class="fun-btn-box">
      <auth-button auth="parking:lot:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 新增车场</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :emptyText="emptyText"
      :pagination="false"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #description="{ row }">{{ row.description?row.description:'---' }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="lookDetaile(scope.row)" class="mr10">查看详情</el-button >
      </template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import { api_getParkingLotList } from '@/api/parking'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "parkingRule",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  props: {
    mallId: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        mallIds:""
      },
      tableThData: [
        { prop: "name", label: "车场名称", minWidth: "100", },
        { prop: "description", label: "收费说明", minWidth: "300", },
        { prop: "operation", label: "操作", minWidth: "60", },
      ],
      emptyText:'',
    };
  },
  mounted(){
     this.form.mallIds = this.mallId
     this.form.mallIds?this.emptyText='暂无数据,请新增...':this.emptyText='-------'
  },
  
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
          mallId:this.form.mallIds
        }
      const data = await api_getParkingLotList(params)
      this.tableTrData =  data || []
      this.loading = false
    },
    onAdd () {
      this.$router.push({
        path: `/parkMangement/config/detail?type=add&mallId=${this.form.mallIds}`
      })
    },
    lookDetaile (row) {
      this.$router.push({
        path: `/parkMangement/config/detail2?mallId=${this.form.mallIds}&type=look&id=${row.id}`
      })
    },
  },
   watch: {
      mallId: {
        immediate: true,
        handler(value,old) {
          this.form.mallIds = value
          this.getList()
        }
      }
    },
  computed: {},
};
</script>
<style lang="scss" scoped>
.parkingConfiguration {
  width: 100%;
  margin-top: 35px;
  box-sizing: border-box;
  ::v-deep{
    .search-box{
      margin-top: 20px;
    }
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .today-sum{
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    .today-sum-item{
      height: 90px;
      width: calc(50% - 7.5px);
      display: flex;
      align-items: center;
      .item-icon{
        margin-left: 50px;
        margin-right: 20px;
        img{
          width: 46px;
          height: 46px;
        }
      }
      .item-content{
        p{
          margin: 0;
        }
        .title{
          font-size: 12px;
          color: #666666;
          margin-bottom: 15px;
        }
        .amount{
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .tips{
          font-size: 12px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #dcdfe6;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fafafa;
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .Billing, .Paying{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Left{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .tipsA{
    font-size: 13px;
    color: #FF8E12;
  }
  .tipsB{
    font-size: 13px;
    color: #999;
  }
  ::v-deep{
    .el-table__body-wrapper::-webkit-scrollbar{
      /*滚动条整体样式*/
      width: 4px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px !important;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #dcdfe6;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: #fafafa;
    }
    .el-table__fixed{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
    .el-table__fixed-right{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
  }
  .image{
    width: 60px;
    height: 60px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>